import { QuoteSheetDetailSlidein } from '@/components/procurement/quote-sheet-detail/quote-sheet-detail-slidein';
import { useNavigate, useParams } from '@tanstack/react-router';

export function Route() {
  const { quoteSheetId } = useParams({
    from: '/authenticated/price-sheet-dashboard/detail/$quoteSheetId',
  });
  const navigate = useNavigate();

  return (
    <QuoteSheetDetailSlidein
      quoteSheetId={quoteSheetId}
      isOpen={true}
      onOpenChange={() => {
        navigate({
          to: '/price-sheet-dashboard',
          viewTransition: true,
        });
      }}
    />
  );
}
